import { PropsWithoutRef } from 'react'

import Icon from '@ant-design/icons'
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon'

import { PhoneSvg } from './PhoneSvg'

export const EaPhoneIcon = (props: PropsWithoutRef<IconBaseProps>) => (
  <Icon component={PhoneSvg} {...props} />
)
